import PaymentRequestsPayModal from './index.vue'
export default PaymentRequestsPayModal